import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    AppBar, Toolbar, Grid, Typography
} from '@mui/material';
import {Add} from '@mui/icons-material';
import HeaderAvatar from "../components/HeaderAvatar";
import {
    fetchUserPermissions,
    fetchProducts
} from '../services/api';
import {usePermissions} from "../components/PermissionsContext";

interface Product {
    id: string;
    name: string;
    image_url: string;
}

const Products: React.FC = () => {
    const { permissions } = usePermissions();
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState<Product[]>([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const fetchProductsData = async () => {
        try {
            setLoading(true);
            const data = await fetchProducts(page);
            setProducts(data.items);
            setHasMore(data.items.length === 100);
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchProductsData();
    }, []);

    return (
        <Box>
            <AppBar className={loading ? 'headerBlock preloading' : 'headerBlock'} position="static">
                <Toolbar className='toolbar'>
                    <Box className='toolbarTitle'>Продукты <span>{products.length}</span></Box>
                    {/*<Button className="addToobarBtn" variant="contained" onClick={() => {}}><Add /></Button>*/}
                    <HeaderAvatar/>
                </Toolbar>
            </AppBar>
            <Box className='productItems'>
                {products.map((product) => (
                    <Box className='productItem' key={product.id}>
                        {product.image_url ?
                            <Box>
                                <img src={product.image_url} alt={product.name}/>
                            </Box>
                            : null}
                        <Box className='productItemText'>
                            {product.name}
                        </Box>
                    </Box>
                ))}
            </Box>

        </Box>
    );
};

export default Products;